<div class="select-city">
  <div class="regions">
    <div class="region active">Вспомогательные помещения</div>
  </div>
  <div class="cities">
    <div class="cities_list">
      <div class="city" *ngFor="let type of auxiliaryPremisesTypes">
        <label class="container-checkbox">{{type.title}}
          <input type="checkbox" [(ngModel)]="type.checked" (ngModelChange)="type.checked = $event" (change)="changedModel()">
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
</div>
<div class="appartment-action">
  <div class="btn" [ngClass]="onchangeModel ? 'btn-apply' : 'btn-cancel'" (click)="onchangeModel ? saveState() : null">Подтвердить</div>
  <div class="btn btn-cancel" (click)="cancel()">Отменить</div>
</div>